<template>
    <main id="air-base">
      <section id="ac-header" class="langing-gradient-bg relative overflow-hidden" style="min-height: 600px;" aria-label="hero section">
        <div class="container z-2">
          <div class="row pt-5" >
              <div id="landing-hero" class="d-flex text-left w-100 mb-50">
                  <div id="landing-content" class="d-flex flex-column justify-content-center align-items-start" >
                      <div class="box-right w-100" data-aos="fade-left">
                          <h1 class="title-header"> 
                            {{ $t("ac_cleaning.hero_section.title") }}
                            <span v-html="$t('ac_cleaning.hero_section.subtitle')"></span>
                          </h1>
                          <small>
                            {{ $t("ac_cleaning.hero_section.description") }}
                          </small>
                      </div>
                      <div data-aos="fade-left" id="ac-contact" class="d-flex gap-2 mt-5">
                          <a id="btn-line" class="px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white line-bg line-text" type="button" 
                          :href="lineUrl" target="_blank">
                            <img src="/static/img/acCleaning/ac-v2/line-messenger-logo.png" alt="line messager icon">
                            {{ $t("ac_cleaning.hero_section.line_consultation") }}
                          </a>
                          <router-link 
                          :to="{ name: 'New Booking', query: { sid: 16 }}"
                          class="px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white bg-secon text-white" type="button">
                              <SVGIcon
                                  class=""
                                  icon="ac-icon.svg"
                                  folder="acCleaning/ac-v2"
                                  alt="air icon booking" />
                              {{ $t("ac_cleaning.hero_section.book_now") }}
                          </router-link>
                      </div>
                  </div>
                  <div>
                      <MobileFlameDisplay :presentation="'/static/img/acCleaning/ac-video/ac-cleaning.mp4'"/>
                  </div>
              </div>
          </div>
        </div>
        <SnowFlake :amount="15" />
      </section>
      <section id="ac-cleaning-info" class="container" aria-label="air conditioner cleaning information">
        <div id="ac-cleaning-services" class="row pt-5">
            <div class="d-flex flex-column justify-content-center align-items-center text-center w-100 pt-5">
              <h3 class="title" data-aos="fade-left" > {{ $t('ac_cleaning.service_section.title') }}</h3>
              <p data-aos="fade-right" >{{ $t('ac_cleaning.service_section.subtitle') }}</p>
            </div>
            <div class="container pt-5">
              <!-- <div class="row justify-content-center">
                <div v-for="(item,index) in acService" :key="index" class="col-md-4 mb-4" data-aos="fade-up" :data-aos-delay="index * 100" data-aos-easing="ease-in-out">
                  <SquareImage
                    :imageName="item"
                    :routeFile="routeFile" />
                </div>
              </div> -->
              <Carousel
                id="ac-service"
                :images="acService" 
                :routeFile="routeFile" 
                />
            </div>
        </div>
        <div id="ac-cleaning-air-type" class="row pt-5" >
            <div class="d-flex flex-column justify-content-center align-items-center text-center w-100 pt-5">
              <h3 class="title" data-aos="fade-left" >{{ $t('ac_cleaning.service_types_section.title') }}</h3>
              <p data-aos="fade-right" >{{ $t('ac_cleaning.service_types_section.subtitle') }}</p>
            </div>
            <div class="container pt-5">
              <div class="row justify-content-center">
                <div v-for="(item,index) in acAirType.infoType" :key="index" class="d-flex px-4 mb-4" data-aos="fade-up" :data-aos-delay="index * 100" data-aos-easing="ease-in-out">
                  <div style="height: 360px; width: 360px;" >
                    <SquareImage
                    :imageName="item.img"
                    :title="item.title ? $t(`ac_cleaning.service_types_section.infoType.${index}.title`) : ''"
                    :text="item.text ? $t(`ac_cleaning.service_types_section.infoType.${index}.text`) : ''"
                    :routeFile="routeFile" />
                  </div>
                </div>
              </div>
            </div>
            <div class="container pt-5">
              <div class="pt-5">
                <h5 data-aos="fade-left">{{ $t('ac_cleaning.service_types_section.type01.title') }}</h5>
                <IconListStyle :dataList="acAirType.contentAirType" svgIcon="checkmark-square-01.svg" />
              </div>
              <div class="pt-5">
                <h5 data-aos="fade-left">{{ $t('ac_cleaning.service_types_section.priceRateWallType.title') }}</h5>
                <ul style="list-style-type:decimal;" class="pl-20">
                  <li class="py-1" v-for="(rate,index) in acAirType.servicePrice" :key="index">
                    <!-- {{ rate.name }} -->
                    {{ $t(`ac_cleaning.service_types_section.priceRateWallType.rate_list.${index}`) }}
                  </li>
                </ul>
              </div>
              <div class="row justify-content-center pt-5">
                <div v-for="(item,index) in acAirType.servicePriceImg" :key="index" class="d-flex px-4 mb-4" data-aos="fade-up" :data-aos-delay="index * 100" data-aos-easing="ease-in-out">
                  <div style="height: 360px; width: 360px;">
                    <SquareImage
                    :imageName="item.img"
                    :title="item.title ? $t(`ac_cleaning.service_types_section.servicePriceImg.${index}.title`) : ''"
                    :text="item.text ? $t(`ac_cleaning.service_types_section.servicePriceImg.${index}.text`) : ''"
                    :routeFile="routeFile" />
                  </div>
                </div>
              </div>
              <div class="pt-5">
                <h5 data-aos="fade-left">{{ $t('ac_cleaning.service_types_section.type02.title') }} </h5>
                <IconListStyle :dataList="acAirType.cassetteType" svgIcon="checkmark-square-01.svg" />
              </div>
              <div class="pt-5">
                <h5 data-aos="fade-left" >{{ $t('ac_cleaning.service_types_section.priceRateCassetteType.title') }}</h5>
                <div id="cassette-type" class="d-flex" style="gap: 10%;">
                  <div>
                    <p>{{ $t('ac_cleaning.service_types_section.priceRateCassetteType.size_list[0].btu_price') }}</p>
                    <ul style="list-style-type:decimal;" class="pl-20">
                      <li class="py-1" 
                      v-for="(rate,index) in acAirType.cassettePrice.smallBTC" 
                      :key="index">
                      <!-- {{ rate.name }} -->
                      {{ $t(`ac_cleaning.service_types_section.priceRateCassetteType.size_list[0].rate_list.${index}`) }}
                    </li>
                    </ul>
                  </div>
                  <div>
                    <p>{{ $t('ac_cleaning.service_types_section.priceRateCassetteType.size_list[1].btu_price') }}</p>
                    <ul style="list-style-type:decimal;" class="pl-20">
                      <li class="py-1" 
                        v-for="(rate,index) in acAirType.cassettePrice.largeBTC" 
                        :key="index">
                        <!-- {{ rate.name }} -->
                        {{ $t(`ac_cleaning.service_types_section.priceRateCassetteType.size_list[1].rate_list.${index}`) }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <WhyBeNeat class="py-4 w-100" />
            <WhyAirCleaning class="py-4 w-100" />
            <ScopeOfWork class="py-4 w-100" />
            <Covered class="py-4 w-100" />
            <TransparentPricing class="py-4 w-100" />
            <MoreThanCleaning class="py-4 w-100" />
            <ApplyForWork :socialContacts="{ professionalLineUrl }" class="py-4 w-100" />
            <HelpCenter  :socialContacts="{ lineUrl, fbMessageUrl }" class="py-4 w-100" />
            <Questions class="py-4 w-100" />
            <DownloadBeNeatApp class="py-4 w-100" />
        </div>
      </section>
      <section id="floating-button-mobile" class="absolute d-flex justify-content-center align-items-center" aria-label="contact buttons">
        <a id="btn-line" class="px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white line-bg line-text" type="button" 
        :href="lineUrl" target="_blank">
          <img src="/static/img/acCleaning/ac-v2/line-messenger-logo.png" alt="line messager icon">
          {{ $t("ac_cleaning.hero_section.line_consultation") }}
        </a>
        <router-link 
          :to="{ name: 'New Booking', params: { sid: 16 }}"
          class="px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white bg-secon text-white" 
          type="button" style="border-radius: 100px;
            border: 1px solid #FFF;
            background: var(#31C1D7);
            box-shadow: 0px 0px 6px 0px #31C1D7;"
        >
            <SVGIcon
                class=""
                icon="ac-icon.svg"
                folder="acCleaning/ac-v2"
                alt="air icon booking" />
            {{ $t("ac_cleaning.hero_section.book_now") }}
        </router-link>
      </section>
    </main>
</template>

<script>
import AOS from 'aos'
import SnowFlake from '../materials/SnowFlake.vue'
import SVGIcon from '../materials/SVGIcon.vue'
import MobileFlameDisplay from '../materials/MobileFlameDisplay.vue'
import SquareImage from '../materials/SquareImage.vue'
import IconListStyle from '../materials/IconListStyle.vue'
import Carousel from '../materials/Carousel.vue'
import WhyBeNeat from '../acCleaningRe/WhyBeNeat.vue'
import WhyAirCleaning from '../acCleaningRe/WhyAirCleaning.vue'
import ScopeOfWork from '../acCleaningRe/ScopeOfWork.vue'
import Covered from '../acCleaningRe/Covered.vue'
import TransparentPricing from '../acCleaningRe/TransparentPricing.vue'
import MoreThanCleaning from '../acCleaningRe/MoreThanCleaning.vue'
import ApplyForWork from '../acCleaningRe/ApplyForWork.vue'
import HelpCenter from '../acCleaningRe/HelpCenter.vue'
import Questions from '../acCleaningRe/Questions.vue'
import DownloadBeNeatApp from '../acCleaningRe/DownloadBeNeatApp.vue'
export default {
  components: {
    SVGIcon,
    SnowFlake,
    MobileFlameDisplay,
    SquareImage,
    IconListStyle,
    Carousel,
    WhyBeNeat,
    WhyAirCleaning,
    ScopeOfWork,
    Covered,
    TransparentPricing,
    MoreThanCleaning,
    ApplyForWork,
    HelpCenter,
    Questions,
    DownloadBeNeatApp
  },
  metaInfo () {
    return {
      title: 'BeNeat บริการล้างแอร์บ้าน คอนโด สำนักงาน ทุก BTU มาตรฐานสูง',
      link: [
        {
          rel: 'canonical',
          href: 'https://beneat.co/ac-cleaning'
        }
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'BeNeat ให้บริการล้างแอร์บ้าน คอนโด สำนักงาน ทุก BTU โดยทีมช่างมืออาชีพ มั่นใจได้มาตรฐาน ลดกลิ่นอับ ไม่มีบวกเพิ่ม ดูแลพื้นที่สะอาดหลังจบงาน พร้อมให้บริการในกรุงเทพฯ ปริมณฑล เชียงใหม่ และชลบุรี'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'ล้างแอร์, ล้างแอร์บ้าน, ล้างแอร์คอนโด, ล้างแอร์สำนักงาน, บริการล้างแอร์, แอร์ไม่เย็น, แอร์มีกลิ่น, ราคาล้างแอร์, ช่างล้างแอร์มืออาชีพ, ล้างแอร์กรุงเทพ, ล้างแอร์ปริมณฑล, ล้างแอร์เชียงใหม่, ล้างแอร์ชลบุรี, ล้างแอร์ทุก BTU, ล้างแอร์ราคาถูก, ล้างแอร์มาตรฐานสูง, ล้างแอร์ลดกลิ่นอับ, ล้างแอร์ไม่มีบวกเพิ่ม'
        },
        {
          vmid: 'image',
          name: 'image',
          content: 'https://beneat.co/static/img/acCleaning/ac-service-1.png'
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'BeNeat บริการล้างแอร์บ้าน คอนโด สำนักงาน ทุก BTU มาตรฐานสูง'
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: 'https://beneat.co/static/img/acCleaning/ac-service-1.png'
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: 'https://beneat.co/ac-cleaning'
        },
        {
          vmid: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          vmid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          vmid: 'twitter:title',
          name: 'twitter:title',
          content: 'BeNeat บริการล้างแอร์บ้าน คอนโด สำนักงาน ทุก BTU มาตรฐานสูง'
        },
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: 'BeNeat ให้บริการล้างแอร์บ้าน คอนโด สำนักงาน ทุก BTU โดยทีมช่างมืออาชีพ มั่นใจได้มาตรฐาน ลดกลิ่นอับ ไม่มีบวกเพิ่ม ดูแลพื้นที่สะอาดหลังจบงาน พร้อมให้บริการในกรุงเทพฯ ปริมณฑล เชียงใหม่ และชลบุรี'
        },
        {
          vmid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://beneat.co/static/img/acCleaning/ac-service-1.png'
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: 'th_TH'
        }
      ]
    }
  },
  created () {
    AOS.init({
      duration: 1000,
      once: true,
      anchorPlacement: 'top-bottom',
      mirror: true
    })
  },
  computed: {
    lineUrl () {
      return process.env.VUE_APP_LINE_ENDPOINT || 'https://line.me/R/ti/p/%40hnk7011n'
    }
  },
  mounted () {
    this.$nextTick(() => {
      AOS.refresh()
    })
  },
  data () {
    return {
      fbMessageUrl: process.env.VUE_APP_FB_MESSAGE_ENDPOINT || 'https://www.messenger.com/t/beneatco/',
      professionalLineUrl: 'https://line.me/R/ti/p/@beneatpro',
      routeFile: 'acCleaning',
      acService: [
        '01.jpg',
        '02.jpg',
        '03.jpg',
        '04.jpg'
      ],
      acAirType: {
        infoType: [
          {
            img: 'ac-air-type-1.png',
            title: 'แอร์ติดผนัง',
            text: 'ราคาเดียวกันทุก BTU '
          },
          {
            img: 'ac-service-1.png',
            title: '',
            text: ''
          }
        ],
        contentAirType: [
          {
            name: 'เหมาะกับห้องที่มีพื้นที่ไม่ใหญ่มาก เช่น ห้องนอน ห้องรับแขก',
            lang: 'ac_cleaning.service_types_section.type01.description'
          },
          {
            name: 'แนะนำล้างทุก 4–6 เดือน หรือเร็วกว่านั้นหาก ใช้งานบ่อย อยู่ใกล้ถนน ฝุ่นเยอะ หรือมีสัตว์เลี้ยง',
            lang: 'ac_cleaning.service_types_section.type01.description'
          }
        ],
        servicePrice: [
          {
            name: 'เครื่อง : ราคา 750 บาท'
          },
          {
            name: 'เครื่อง : ราคา 1,425 บาท'
          },
          {
            name: 'เครื่อง : ราคา 2,025 บาท'
          },
          {
            name: 'เครื่อง : ราคา 2,700 บาท'
          }
        ],
        servicePriceImg: [
          {
            img: 'service-price-rate-1.png',
            title: 'แอร์สี่ทิศทาง',
            text: 'ราคาเริ่มต้น 1,700 บาท'
          },
          {
            img: 'ac-service-3.png',
            title: '',
            text: ''
          }
        ],
        cassetteType: [
          {
            name: 'นิยมใช้ในร้านค้า สำนักงาน คาเฟ่ หรือพื้นที่โล่ง',
            lang: 'ac_cleaning.service_types_section.type02.description'
          },
          {
            name: 'ติดตั้งบนฝ้าเพดาน เป่าลมได้ 4 ทิศทาง กระจายความเย็นทั่วถึง',
            lang: 'ac_cleaning.service_types_section.type02.description'
          },
          {
            name: 'ระบบซับซ้อนกว่าแอร์ติดผนัง ต้องใช้ผู้เชี่ยวชาญเฉพาะ',
            lang: 'ac_cleaning.service_types_section.type02.description'
          },
          {
            name: 'แนะนำล้างทุก 3–4 เดือน เพราะใช้ในพื้นที่ที่มีการใช้งานหนัก และมีฝุ่น/ความชื้นสะสมมากกว่า',
            lang: 'ac_cleaning.service_types_section.type02.description'
          }
        ],
        cassettePrice: {
          smallBTC: [
            {
              name: 'เครื่อง : ราคา 1,700 บาท'
            },
            {
              name: 'เครื่อง : ราคา 3,400 บาท'
            },
            {
              name: 'เครื่อง : ราคา 5,100 บาท'
            },
            {
              name: 'เครื่อง : ราคา 6,460 บาท'
            }
          ],
          largeBTC: [
            {
              name: 'เครื่อง : ราคา 2,000 บาท'
            },
            {
              name: 'เครื่อง : ราคา 4,000 บาท'
            },
            {
              name: 'เครื่อง : ราคา 6,025 บาท'
            },
            {
              name: 'เครื่อง : ราคา 7,600 บาท'
            }
          ]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../static/sass/page/ac_cleaning.scss';
@import "~aos/dist/aos.css";

#floating-button-mobile {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: none !important;
  gap: 16px;
  padding: 0 16px;

  & img {
    width: 24px;
    height: 24px;
  }
}

#btn-line,
#floating-button-mobile .router-link {
  text-align: center;
}

@media (max-width: 768px) {
  #floating-button-mobile {
    display: flex !important;
  }
}

@media only screen and (max-width: 768px) {
  #landing-hero {
    justify-content: center;
  }
  #landing-hero #landing-content {
    display: none !important;
  }

  #cassette-type {
    flex-direction: column;
  }
}
@media only screen and (max-width: 450px) {
  .container {
    padding: 0 !important;
  }
  .row.pt-5 {
    padding-top: 0 !important;
  }
}


</style>




// WEBPACK FOOTER //
// src/components/information/AcCleaningV2.vue